"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.complexDataMix = exports.skipAddToCacheOnConstruct = void 0;
const { Mixin, settings, } = require('ts-mixer');
exports.skipAddToCacheOnConstruct = Symbol('skipAddToCacheOnConstruct');
function complexDataMix(...MixerClasses) {
    settings.initFunction = 'complexDataMixConstructor';
    return function (target) {
        Object.defineProperty(target, exports.skipAddToCacheOnConstruct, {
            value: true,
            writable: false,
        });
        const mixedClass = Mixin(target, ...MixerClasses);
        Object.defineProperty(mixedClass, 'name', {
            value: target.name,
            writable: false,
        });
        return mixedClass;
    };
}
exports.complexDataMix = complexDataMix;
//# sourceMappingURL=../../../src/decorator/index.js.map